class BestSellers extends HTMLElement {
  constructor() {
    super()
    this.tabs = null
    this.panels = null
    this.onTabClick = this.handleTabClick.bind(this)
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.home-best-sellers-tab')
    this.panels = this.querySelectorAll('.home-best-sellers-panel')
    this.tabs.forEach(tab => tab.addEventListener('click', this.onTabClick))
  }

  disconnectedCallback() {
    this.tabs?.forEach(tab => tab.removeEventListener('click', this.onTabClick))
  }

  handleTabClick(event) {
    const targetId = event.currentTarget.dataset.target

    // Remove active state from all tabs
    this.tabs.forEach(t => {
      t.classList.remove('active')
      t.setAttribute('aria-selected', 'false')
    })

    // Hide all panels
    this.panels.forEach(p => p.classList.remove('active'))

    // Add active class to clicked tab
    event.currentTarget.classList.add('active')
    event.currentTarget.setAttribute('aria-selected', 'true')

    // Show target panel
    const targetPanel = this.querySelector(`#${targetId}`)
    if (targetPanel) {
      targetPanel.classList.add('active')
      // Trigger resize to ensure splide recalculates width
      window.dispatchEvent(new Event('resize'))
    }
  }
}

customElements.define('best-sellers', BestSellers)
